import { httpGet, httpDel, httpPut, httpPost } from '@/tool/request/index';
import Conf from '@/tool/request/config';
//获取获取上传文件url
export async function electronicGetPreSignedPutObject(fileName) {
  return await httpGet<API.RootResponse>(`/electronic/cos/getPresignedPostFormData?fileName=${fileName}`)();
}

//获取获取上传文件url
export async function getPresignedPostFormData(fileName) {
  return await httpGet<API.RootResponse>(`/electronic/cos/getPresignedPostFormData?fileName=${fileName}`)();
}



//根据电子文件id删除电子文件
export async function electronicDeleteFile(eleId: string) {
  return await httpDel<API.RootResponse>('/electronic/deleteFile')({
    params: { eleId },
    isUrlQs: true,
  });
}

// 通过名字获取详情
export async function getPreSignedPutObject(fileName: string) {
  return await httpGet<API.RootResponse>('/electronic/getPresignedPostFormData?fileName=' + fileName)();
}

// 关联图片服务器
export async function setAssociateImageServer(entryId: string, filePath: string) {
  return await httpPut<API.RootResponse>(`/electronic/upload?entryId=${entryId}&filePath=${filePath}`)();
}



// 通过名称获取服务器文件地址
export async function getFileServerUrl(fileName: string) {
  return await httpGet<API.RootResponse>(`/electronic/getPreSignedPutObject?fileName=${fileName}`)();
}

// 语音转文字
export async function startSpeechToText(data: any) {
  return await httpPost<API.RootResponse>(`/audio_to_text`, Conf.audiohost)({
    data
  });
}
